import { render, staticRenderFns } from "./cocal-sweep-list.vue?vue&type=template&id=2b0e260e&scoped=true&"
import script from "./cocal-sweep-list.vue?vue&type=script&lang=js&"
export * from "./cocal-sweep-list.vue?vue&type=script&lang=js&"
import style0 from "./cocal-sweep-list.vue?vue&type=style&index=0&id=2b0e260e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e260e",
  null
  
)

export default component.exports